import { IconWithTooltip } from '../../Icon'

import * as styles from './TableCellInfo.module.css'

import InformationIcon from '../../../icons/info.svg'

function TableCellInfo({
  Icon = InformationIcon,
  className = styles.TableCellInfo,
  value,
}) {
  return <IconWithTooltip Icon={Icon} className={className} tooltip={value} />
}

export default TableCellInfo
